import React from 'react'
import "./style.css"

function index() {
  return (
    <svg className='clock' viewBox="0 0 70 100" width="70" height="13">
  <defs>
    <path id="hourglass" d="M 5 5 h 60 q 0 22.5 -28 45 28 22.5 28 45 h -60 q 0 -22.5 28 -45 -28 -22.5 -28 -45z" />
    <clipPath id="clip--hourglass">
      <use href="#hourglass" />
    </clipPath>
  </defs>
  <g clip-path="url(#clip--hourglass)">
    <rect id="sand" width="70" height="50" fill="#fdd155" stroke="none" />
  </g>
  <g stroke="hsl(240, 15%, 5%)" stroke-width="5" fill="none" stroke-linecap="round" stroke-linejoin="round">
    <use href="#hourglass" />
  </g>
  <g fill="hsl(240, 15%, 5%)" stroke="none">
    <rect width="70" height="5" />
    <rect width="70" height="5" y="95" />
  </g>
</svg>
  )
}

export default index